<div class="numero_piezas">{{ numeroPiezas }}</div>
<div class="descripcion">En producción</div>
